module.exports = __webpack_public_path__ + "img/EXODONCIA_QUIRURGICA_IND.png";